import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosHttp from "services/axiosHttp";

//CREATE ACTION
export const createUserTypes = createAsyncThunk("createUserTypes", async (values, { rejectWithValue }) => {
	try {
		const response = await axiosHttp.post(`/channel/user_type`, values);
		return response.data;
	} catch (err) {
		if (!err.response) {
			throw err;
		}
		return rejectWithValue(err.response.data);
	}
});

const CreateUserTypeSlice = createSlice({
	name: "CreateUserTypeSlice",
	initialState: {
		isLoading: false,
		isError: false,
		error: null,
		data: null,
	},

	reducers: {
		resetCreateUserTypeState: (state) => {
			state.isLoading = false;
			state.isError = false;
			state.error = null;
			state.data = null;
		},
	},

	extraReducers: (builder) => {
		builder.addCase(createUserTypes.pending, (state) => {
			state.isLoading = true;
			state.isError = false;
		});

		builder.addCase(createUserTypes.fulfilled, (state, action) => {
			state.isLoading = false;
			state.isError = false;
			state.data = action.payload;
		});

		builder.addCase(createUserTypes.rejected, (state, action) => {
			state.isLoading = false;
			state.isError = true;
			state.error = action.payload;
		});
	},
});

export const { resetCreateUserTypeState } = CreateUserTypeSlice.actions;
export default CreateUserTypeSlice.reducer;
